import { createContext } from 'react';

const DailyEngagedUsersContext = createContext();


export default DailyEngagedUsersContext;